import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import useClaims from '@/hooks/useClaims';
const ProtectedRoute = () => {
    const { isAuthenticated, isLoading } = useAuth0();
    const { loadUserMetadata } = useClaims();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (isLoading || !isAuthenticated)
            return;
        loadUserMetadata().catch(e => {
            console.error(e);
            navigate('/login?error=common.invalidUser', { replace: true });
        });
    }, [isAuthenticated, isLoading, loadUserMetadata, navigate]);
    const Component = withAuthenticationRequired(Outlet, {
        returnTo: pathname,
        onRedirecting: () => _jsx(CircularProgress, {}),
    });
    return _jsx(Component, {});
};
export default ProtectedRoute;
